document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-cloud-quantity]').forEach((control) => {
    const input = control.querySelector('input');
    const form = control.closest('form');
    const submit = () => form?.submit();
    control.querySelector('[data-minus]')?.addEventListener('click', () => {
      input.value = Math.max(0, Number(input.value) - 1);
      submit();
    });
    control.querySelector('[data-plus]')?.addEventListener('click', () => {
      input.value = Number(input.value) + 1;
      submit();
    });
    input.addEventListener('change', submit);
  });
});
